import React from 'react';
import PropTypes from 'prop-types';
import { FlagOutlined, FolderOutlined } from '@ant-design/icons';
import { Card, Select, Button, Menu } from 'antd';

import './Draggable.scss';

const SubMenu = Menu.SubMenu;
const Option = Select.Option;

class Draggable extends React.Component {
  static propTypes = {
    selected: PropTypes.number.isRequired,
    moveSolicitations: PropTypes.func.isRequired,
    changeSelection: PropTypes.func,
    closePopUp: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
  };

  static defaultProps = {
    changeSelection: key => {
      console.log(key);
    },
  };

  constructor() {
    super();
    this.state = {
      selectedMenu: 'folder',
    };
  }

  componentDidMount() {
    this.dragElement(document.getElementById('mydiv'));
    this.props.changeSelection('tbq');
  }
  dragElement = elmnt => {
    let pos1 = 0;
    let pos2 = 0;
    let pos3 = 0;
    let pos4 = 0;
    elmnt.style.right = '46%';
    elmnt.style.bottom = '46%';
    const closeDragElement = () => {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    };
    const elementDrag = e => {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:

      elmnt.style.top = `${elmnt.offsetTop - pos2}px`;
      elmnt.style.left = `${elmnt.offsetLeft - pos1}px`;
      elmnt.style.right = 'inherit';
      elmnt.style.bottom = 'inherit';
    };
    const dragMouseDown = e => {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    };
    if (document.getElementById(`${elmnt.id}header`)) {
      // if present, the header is where you move the DIV from:
      document.getElementById(`${elmnt.id}header`).onmousedown = dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }
  };

  selectMenu = item => {
    this.setState({
      selectedMenu: item.key,
    });
  };

  render() {
    const {
      selected,
      moveSolicitations,
      changeSelection,
      closePopUp,
      selectedTab,
    } = this.props;

    let text;
    switch (this.state.selectedMenu) {
      case 'folder':
        text = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ fontWeight: '600' }}>Move to</div>
            <Select
              onChange={changeSelection}
              defaultValue=""
              style={{ minWidth: 120, paddingLeft: '4px' }}
              // onChange={handleChange}
            >
              {/* <Option value="unflagged">Unflagged</Option> */}
              <Option value="untracked">Remove</Option>

              {/* <Option value="flagged">Flagged</Option> */}
              {selectedTab !== 'tbq' && (
                <Option value="tbq">To be Quoted</Option>
              )}
              {selectedTab !== 'inprocess' && (
                <Option value="inprocess">In Process</Option>
              )}
              {/* <Option value="pendingrequests" disabled>
                  pending Requests
                </Option> */}
              {selectedTab !== 'archived' && (
                <Option value="archived">Archived</Option>
              )}
            </Select>
          </div>
        );
        break;
      case 'mail':
        text = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ fontWeight: '600' }}>
              Send a RFQ for {selected} Solicitations
            </div>
          </div>
        );
        break;

      case 'flag':
        text = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ fontWeight: '600' }}>Add flags</div>
          </div>
        );
        break;
      case 'unflag':
        text = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{ fontWeight: '600' }}>Remove flags</div>
          </div>
        );
        break;

      default:
        break;
    }

    return (
      <div id="mydiv">
        <Card type="inner" title={`Solicitation Actions (${selected})`}>
          <div style={{ display: 'flex' }}>
            <Menu
              defaultSelectedKeys={['folder']}
              inlineCollapsed
              mode="inline"
              onSelect={this.selectMenu}
            >
              <Menu.Item key="folder">
                <FolderOutlined />
                <span>Folder Options</span>
              </Menu.Item>

              <SubMenu
                key="sub1"
                title={
                  <span>
                    <FlagOutlined />
                    <span>flag</span>
                  </span>
                }
              >
                <Menu.Item key="flag">Flag</Menu.Item>
                <Menu.Item key="unflag">Remove Flags</Menu.Item>
              </SubMenu>
            </Menu>
            <div style={{ display: 'flex', marginLeft: '8px' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  minWidth: '230px',
                }}
              >
                {text}

                <br />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '87%',

                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="danger"
                    onClick={() => {
                      closePopUp();
                    }}
                  >
                    Close
                  </Button>
                  {this.state.selectedMenu === 'mail' && (
                    <Button
                      type="primary"
                      onClick={() => moveSolicitations(this.state.selectedMenu)}
                    >
                      Continue
                    </Button>
                  )}
                  {this.state.selectedMenu !== 'mail' && (
                    <Button
                      type="primary"
                      onClick={() => moveSolicitations(this.state.selectedMenu)}
                    >
                      Confirm
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default Draggable;



// WEBPACK FOOTER //
// ./src/components/DraggableEntity/Draggable.jsx